export const useNumberFormat = () => {
  const format = (value) => {
    return new Intl.NumberFormat().format(value);
  };

  return {
    format
  };
};